<template>
  <div class="home">
    <div class="banner">
      <video src="@/assets/video/banner.mp4" autoplay loop></video>
    </div>
    <div class="bannerBtmLine">
      <div class="leftLine"></div>
      <div class="rightLine"></div>
    </div>
    <div class="mainTop">
      <span class="Breadcrumb">
        <router-link to="/">{{ $t("Homepage") }}</router-link></span
      >
      <div class="topLine"></div>
    </div>
    <div class="MonterreyCasino">
      <div class="History">
        <div class="content">
          <h2>{{ $t("MCHH") }}</h2>
          <span>―</span>
          <p class="first">{{ $t("MCHP1") }}</p>
          <p>{{ $t("MCHP2") }}</p>
        </div>
      </div>
      <div class="item">
        <div class="ItemImg">
          <img src="@/assets/img/home-1-891x535.png" alt="" />
        </div>
        <div class="ItemContent">
          <h2>{{ $t("MCI1H") }}</h2>
          <span>―</span>
          <p>{{ $t("MCI1P1") }}</p>
          <p>{{ $t("MCI1P2") }}</p>
        </div>
        <router-link class="ItemBtn" to="/Introduction/1">
          {{ $t("MCBtn") }}
        </router-link>
      </div>
      <div class="item">
        <div class="ItemImg">
          <img src="@/assets/img/home-2-891x535.png" alt="" />
        </div>
        <div class="ItemContent">
          <h2>{{ $t("MCI2H") }}</h2>
          <span>―</span>
          <p>{{ $t("MCI2P1") }}</p>
        </div>
        <router-link class="ItemBtn" to="/Introduction/2">{{
          $t("MCBtn")
        }}</router-link>
      </div>
      <div class="item">
        <div class="ItemImg">
          <img src="@/assets/img/home-3-891x535.png" alt="" />
        </div>
        <div class="ItemContent">
          <h2>{{ $t("MCI3H") }}</h2>
          <p>{{ $t("MCI3P1") }}</p>
          <p>{{ $t("MCI3P2") }}</p>
          <span>―</span>
          <p>{{ $t("MCI3P3") }}</p>
        </div>
        <router-link class="ItemBtn" to="/Introduction/3">{{
          $t("MCBtn")
        }}</router-link>
      </div>
      <div class="item">
        <div class="ItemImg">
          <img src="@/assets/img/home-4-891x535.png" alt="" />
        </div>
        <div class="ItemContent">
          <h2>{{ $t("MCI4H") }}</h2>
          <span>―</span>
          <p>{{ $t("MCI4P1") }}</p>
        </div>
        <router-link class="ItemBtn" to="/Introduction/4">{{
          $t("MCBtn")
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  .banner {
    width: 100%;
    display: flex;
    justify-content: center;

    video {
      width: 100%;
      max-height: 478.98px;
      object-fit: fill;
      &:focus {
        border: none;
        outline: none;
      }
    }
  }
  .MonterreyCasino {
    .History {
      display: flex;
      justify-content: flex-end;
      padding: 48px;
      .content {
        color: #d7af21;
        width: 80%;
        padding: 0 16px;
        h2 {
          font-size: 36px;
        }
        span {
          display: block;
          font-size: 26px;
          padding-bottom: 16px;
        }
        .first:first-letter {
          font-size: 26px;
          text-transform: uppercase;
        }
        p {
          font-size: 18px;
          line-height: 24px;
          padding-bottom: 16px;
          letter-spacing: 1px;
        }
      }
    }
    .item:nth-child(even) {
      background-color: rgb(246, 246, 246);
    }
    .item {
      box-sizing: border-box;
      padding: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .ItemImg {
        width: 100%;
        background-color: white;
        box-sizing: border-box;
        padding: 16px;
        box-shadow: 3px 3px 1rem black;
      }
      .ItemContent {
        color: #d7af21;
        width: 80%;
        padding: 24px;
        h2 {
          font-size: 36px;
        }
        span {
          display: block;
          font-size: 26px;
          padding-bottom: 16px;
        }
        p {
          font-size: 18px;
          line-height: 24px;
          letter-spacing: 1px;
        }
      }
      .ItemBtn {
        white-space: nowrap;
        background: linear-gradient(
          rgba(95, 105, 49, 1) 25%,
          rgba(155, 172, 96, 1) 75%
        );
        color: white;
        font-size: 22px;
        padding: 8px 32px;
        margin-bottom: 24px;
        border: unset;
        &:focus {
          outline: unset;
        }
        &:hover {
          cursor: pointer;
        }
      }
      @media screen and (max-width: 1140px) {
        .ItemBtn {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
